import { createContext, useState } from "react";

const TransactionHistoryContext = createContext<any>(null);

export default TransactionHistoryContext;

export const defaultPayloadDataState = {
    showPaymentTransaction: true,
    showWalletTransaction: true,
    //walletLastSelectedItem: 39,
    //paymentLastSelectedItem: null,
   // walletLastSelectedTime: 1744023197000,
   // fieldToFetch: null,
    count: 15,
    filterCodes: ['THTF_000'],
    // dateFilter: {
    //     startTime: null,
    //     endTime: null,
    // }
}

type defaultPayloadDataStateType = {
    showPaymentTransaction?: boolean,
    showWalletTransaction?: boolean,
    walletLastSelectedItem?: number,
    paymentLastSelectedItem?: number,
    walletLastSelectedTime?: number,
    fieldToFetch?: string,
    count?: number,
    filterCodes?: string[],
    dateFilter?: {
        startTime?: number,
        endTime?: number,
    }
}

export const TransactionHistoryProvider = ({ children }: { children: React.ReactNode }) => {
    const [PayloadDataState, setPayloadDataState] = useState<defaultPayloadDataStateType>(defaultPayloadDataState);
    const [fetchFirstPage, setFetchFirstPage] = useState<boolean>(true);
    const [tabChange, setTabChange] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [transactionHistoryFilters, setTransactionHistoryFilters] = useState<any>(null);
    const [transactionHistory, setTransactionHistory] = useState<any>([]);
    const [error, setError] = useState<any>(null);
    const [activeTab, setActiveTab] = useState<string | null>(null);
    const [loadMore, setLoadMore] = useState<boolean>(false);
    const [walletLastSelectedItemState, setWalletLastSelectedItemState] = useState<number>(0);
    const [walletLastSelectedTimeState, setWalletLastSelectedTimeState] = useState<number>(0);

    const [remainCount, setRemainCount] = useState<number>(0);

    return (
        <TransactionHistoryContext.Provider value={{ PayloadDataState, setPayloadDataState, fetchFirstPage, setFetchFirstPage, tabChange, setTabChange, loading, setLoading, transactionHistoryFilters, setTransactionHistoryFilters, transactionHistory, setTransactionHistory, error, setError, activeTab, setActiveTab, loadMore, setLoadMore, walletLastSelectedItemState, setWalletLastSelectedItemState, walletLastSelectedTimeState, setWalletLastSelectedTimeState, remainCount, setRemainCount }}>{children}</TransactionHistoryContext.Provider>
    );
};
